<template>
    <v-tooltip bottom>
        <v-btn
            v-if="!edit"
            slot="activator"
            outline
            color="black"
            text-color="white"
            dark
            class="d-inline-block"
            @click.native="handleOpenDialog"
        >
            <v-icon
            class="material-icons"
            dark
            color="teal"
            style="padding-right: 10px;font-size: 13px!important;position: absolute;left: -8%;"
            >add</v-icon>
            <v-icon class="material-icons" dark color="teal" style="padding-right: 10px;">domain</v-icon>
            <small>Adicionar imóvel</small>
        </v-btn>
        <v-btn v-else-if="edit" slot="activator" dark icon small flat @click.native="handleOpenDialogEdit">
          <v-icon class="material-icons">edit</v-icon>
        </v-btn>
        <span v-if="!edit">Adicionar um novo imóvel</span>
        <span v-else>Editar imóvel</span>

        <v-dialog
          @keydown.esc="handleCancelar"
          persistent
          v-model="dialog"
          max-width="760px"
        >
          
          <v-card>
            <v-toolbar dark class="headline darkBlue">
              <v-toolbar-title v-if="!edit">Adicionar novo Imóvel</v-toolbar-title>
              <v-toolbar-title v-else>Editar Imóvel</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon dark @click.native="handleCancelar">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <article>

            <v-card-text style="width: 90%;margin: auto;" class="form_empresa_inputs">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                <v-layout row wrap>

                    <v-flex xs12 sm6>
                        <v-text-field
                          v-model="inscricao"
                          label="Numero da Inscrição do Imóvel "
                          class="input-required"
                          required
                          clearable
                          validate-on-blur
                          @keypress="isNumber($event)"
                          :rules="razaoRules"
              
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-autocomplete
                            v-model="pagamento"
                            :items="comboPagamento"
                            class="input-required"
                            label="Forma de Pagamento"
                            required
                            clearable
                            validate-on-blur
                            :rules="razaoRules"
                        ></v-autocomplete>
                    </v-flex>

                    

                    <v-flex xs12 sm6>
                        <v-autocomplete
                          v-model="uf"
                          validate-on-blur
                          item-text="sigla"
                          class="input-required"
                          :items="arrayEstados"
                          label="Estado"
                          clearable
                          persistent-hint
                          no-data-text="Consulta de Estado indisponível"
                          return-object
                          @change="getMunicipios"
                          :rules="razaoRules"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-autocomplete
                            label="Município"
                            validate-on-blur
                            item-text="nome"
                            :items="arrayMunicipios"
                            v-model="municipio"
                            clearable
                            class="input-required"
                            persistent-hint
                            no-data-text="Selecione um Estado"
                            return-object
                            :rules="razaoRules"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm8>
                        <v-textarea
                            v-model="description"
                            label="Descrição do Imóvel"
                            clearable
                            auto-grow
                            row-height="4"
                            style="font-size: 0.8em;"
                            validate-on-blur
                        ></v-textarea>
                    </v-flex>

                    <v-flex xs12 sm4>
                        <v-text-field
                          v-model="prefixo"
                          label="Prefixo do nome do arquivo"
                          clearable
                          validate-on-blur
                        ></v-text-field>
                      </v-flex>

                </v-layout>
                </v-container>
            </v-form>
            </v-card-text>
            <v-container grid-list-md text-xs-center style="padding-top: 2px;">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      block
                      outline
                      depressed
                      small
                      color="red"
                      @click="handleCancelar"
                    >Cancelar</v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      block
                      depressed
                      class="white--text"
                      small
                      color="teal"
                      @click="onSubmit"
                    >{{ !edit ? 'Adicionar' : 'Atualizar' }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </article>
          </v-card>
        </v-dialog>


        </v-tooltip>
</template>

<script>
import IptuService from "@/domain/automacaoFiscal/iptu/IptuService";
export default {
    props: ["edit", "IBGE", "nota", "empresa"],
    data() {
        return {
          dialog: false,
          inscricao: '',
          prefixo: '',
          uf: '',
          municipio: '',
          description: '',
          pagamento: '',
          arrayEstados: [],
          arrayMunicipios: [],
          comboPagamento: [
              'A vista',
              'Parcelado',
              'Ambos'
          ],
          valid: true,
          id: '',
          razaoRules: [v => !!v || "Campo obrigatório"],
        }
    },
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        handleOpenDialog() {
            if(!this.arrayEstados.length) {
                this.arrayEstados = this.IBGE.estados;
                this.arrayMunicipios = [];
            }
            this.dialog = true;
        },
        handleOpenDialogEdit() {
          if(!this.arrayEstados.length) {
            this.arrayEstados = this.IBGE.estados;
            this.arrayMunicipios = [];
          }
          for(let i in this.arrayEstados) {
            if(this.arrayEstados[i].sigla == this.nota.uf) {
              this.uf = this.arrayEstados[i];
              this.getMunicipios(this.nota.codMun);
              break;
            }
          }
          this.prefixo = this.nota.prefixo;
          this.inscricao = this.nota.inscricaoImovel;
          if(this.nota.pagtoIptu == 'avista') {
            this.pagamento = 'A vista';
          }else if(this.nota.pagtoIptu == 'parcelado') {
            this.pagamento = 'Parcelado';
          } else if(this.nota.pagtoIptu == 'ambos') {
            this.pagamento = 'Ambos';
          } else {
            this.pagamento = '';
          }
        
          this.description =  this.nota.descricao;
          this.id = this.nota._id;
  
          this.dialog = true;
        },
        getMunicipios: async function(codMun = '') {
          if (this.uf) {
              this.resource = this.$resource(
              `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.uf.id}/municipios`
              );
              this.resource.query().then(
              success => {
                  if(codMun.length > 1){
                    if(success.body.length) {
                        for(let i in success.body) {
                          if(success.body[i].id == codMun) {
                              this.municipio = success.body[i];
                              break;
                          }
                        }
                    }
                  }
                  this.arrayMunicipios = success.body;
              },
              failed => {
                  this.arrayMunicipios = [];
              }
              );
          }else {
              return;
          }
        },
        resetForm() {
        this.$refs.form.reset()
        },
        handleCancelar() {
        this.dialog = false;
        this.arrayMunicipios = [];
        this.resetForm();
        },
        async onSubmit() {
        if (this.$refs.form.validate()) {

            const imovel = {
              empresa: this.empresa._id,
              descricao: this.description,
              uf: this.uf.sigla,
              codUf: this.uf.id,
              municipio: this.municipio.nome,
              codMun: this.municipio.id,
              inscricaoImovel: this.inscricao,
              pagtoIptu: this.pagamento.toLowerCase().replace(' ', ''),
              prefixo: this.prefixo,
            }

            this.snackbar = true
            this.dialog = false;
            this.resetForm();

            this.service = new IptuService(this.$http);
            
            if(!this.edit) {
              await this.service.setImovel(imovel);
            }else {
              await this.service.updateImovel(imovel, this.id);
            }
            this.$store.commit('addUpdateTable', true);
          }
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/configuracoes/configuracoesAutomacao/BtnNovoImovel/BtnNovoImovel.vue